import { AppThunk } from '../../type'
import { finish, loading, set, bulk, setRejectedAmount } from './slice'
import { setLoading } from '../common/slice'
import { getRejectedInvoices } from '../../../features/InvoiceData/RejectedInvoices/api'
import { RejectedInvoicesRequestArgs } from './types'
import axios from 'axios'

export const getRejectedInvoicesListActionAsync =
  (args: RejectedInvoicesRequestArgs): AppThunk =>
  async (dispatch) => {
    try {
      if (!args.offset) dispatch(setLoading(true))
      dispatch(loading())

      if (args.cancelToken) {
        args.cancelToken.current = axios.CancelToken.source()
      }
      const { data } = await getRejectedInvoices({
        params: args,
        cancelToken: args.cancelToken?.current
          ? args.cancelToken.current.token
          : undefined
      })

      if (data) {
        if (args?.offset && Number(args.offset) !== 0) {
          dispatch(bulk(data.results))
          return
        }

        dispatch(
          set({
            ...data,
            search: args.search || null
          })
        )
        dispatch(setRejectedAmount(data.count))
      }

      await Promise.resolve()
    } catch (err) {
      await Promise.reject(err)
    } finally {
      dispatch(finish())
      dispatch(setLoading(false))
    }
  }
